import { jsx as t } from "@emotion/react/jsx-runtime";
import { RejectedFilesContainer as c } from "./RejectedDocumentThumbs.styled.js";
import { RejectedMultipleDocumentThumb as r } from "../RejectedMultipleDocumentThumb/RejectedMultipleDocumentThumb.js";
import { RejectedSingleDocumentThumb as i } from "../RejectedSingleDocumentThumb/RejectedSingleDocumentThumb.js";
const f = ({
  files: e,
  type: m,
  errorTitle: o,
  errorTranslations: n
}) => /* @__PURE__ */ t(c, { direction: "column", alignItems: "flex-start", justifyContent: "center", children: e.length === 1 ? /* @__PURE__ */ t(i, { file: e[0], type: m, errorTranslations: n }, `rejected-file__${e[0]?.file?.name}`) : /* @__PURE__ */ t(r, { files: e, type: m, errorTitle: o, errorTranslations: n }) });
export {
  f as RejectedDocumentThumbs
};
